import { ProductMove } from 'depoto-core/src/entities'

export interface QueuedProductMoveCandidate {
  productId: number
  batch: ProductMove['batch']
  expirationDate: ProductMove['expirationDate']
  position1: ProductMove['position1']
  position2: ProductMove['position2']
  position3: ProductMove['position3']
  supplier: ProductMove['supplier']
  purchaseCurrency: ProductMove['purchaseCurrency']
  purchaseCurrencyDate: ProductMove['purchaseCurrencyDate']
  note: ProductMove['note']
  purchasePrice: ProductMove['purchasePrice']
}

function matchesOptionalValue(left: unknown, right: unknown): boolean {
  return left == right || (!left && !right)
}

export function findEquivalentQueuedProductMove(
  moves: readonly ProductMove[],
  candidate: QueuedProductMoveCandidate,
  excludedMove?: ProductMove
): ProductMove | undefined {
  return moves.find(
    move =>
      move !== excludedMove &&
      move.product.id == candidate.productId &&
      matchesOptionalValue(move.batch, candidate.batch) &&
      matchesOptionalValue(move.expirationDate, candidate.expirationDate) &&
      matchesOptionalValue(move.position1, candidate.position1) &&
      matchesOptionalValue(move.position2, candidate.position2) &&
      matchesOptionalValue(move.position3, candidate.position3) &&
      matchesOptionalValue(move.supplier, candidate.supplier) &&
      matchesOptionalValue(move.purchaseCurrency, candidate.purchaseCurrency) &&
      matchesOptionalValue(move.purchaseCurrencyDate, candidate.purchaseCurrencyDate) &&
      matchesOptionalValue(move.note, candidate.note) &&
      (Number(move.purchasePrice) == Number(candidate.purchasePrice) ||
        (!move.purchasePrice && !candidate.purchasePrice))
  )
}
